import { cx } from '@linaria/core';
import { ChangeEvent, MouseEvent, ReactNode } from 'react';
import { controlDenseStyles, controlDisabledStyles, controlFullWidthLabelStyles, controlLabelStartStyles, controlRootStyles, controlSmallStyles } from './controlStyles';
import { useCenterRipple } from './ripple';
import "./Checkbox.linaria.module.css!=!./Checkbox?./Checkbox.linaria.module.css?css=H4sIAAAAAAAAA52V246bMBCG7/sU3KyyKy0R5hRC1at9jKqyDLbBYGzHNqes+u4VJCSbJttNeoEEP8z3D8PMsEa2gXsqO7+CYAxDyamzzqWwWnI3k8N7JjUm2tUIs9akoRq+//62noJ2lnEMgQ5A3qtr5SdGFrl5SfKa4B8rq1uy+vUXGuV1oWUrsJtLLnWat1oTYd+mi8XGj3q/9yAYR4rzzdfUNEXUEv0+SUTYdLVaSOW+6soRGiv6JLkfpKRhlkmRosxI3lqy8IIyiXoKgTEZw+X9QCtVGnlPCwYkFY6a8XEOJ9RegGLMu2DzOKhn2JYXpG2oOpxDIM1O+t39pJKworQp8M6skXNAGwiqPAgHcz/q0HepkZxhp0P62XXP/fKy0KtyLzYJ7KzyUXutPGrnHkrhOb4a5sNbjNQoqtpAQGgZGfTAx9ZIGCp1k85nHFny7Ebe06vjxtHTi6OlnaQwwqQ4vRXwVB0oCkHlJ9Xg39IuzF7vjbpnKA+FOAzknLNC01AuuYk+rrbZhcmldCOzL2P+Z1ncyO24Kwo+9rR5fFUIKU7DDXjDxig4botzmFFMiH9thcLz424LGVa0CK/jmDDEpqe2ApUOjN5BsInVjnTXzx/HYOrFj6PABMot64hbaDKe+2bXZFwEENDaRNlwS/vMwbVSHQt7cJgLl8nBlWp6z8O9k5PY1tLHy6r5FHr8a3xYLTthVcZgaONuDK7jkGANmus6DwYTxRuXed0zQ5zE8xrjcCYI0g4TlAk2l/0PN2eR8MMGAAA="
const checkboxBoxStyles = "atm_zfov2j_1y44olf atm_qtild_1r31cwp atm_25w2w0_1yyfdc7 atm_hzjvhy_stnw88 atm_3h85wf_1ssbidh atm_18jd5my_1ssbidh atm_16dlv37_1ssbidh atm_194pvdc_1osqo2v atm_yll1fm_1jc34xs atm_jhzn78_vtp2au atm_pynjks_1efh5sa";
const checkboxLoadingStyles = "atm_10pk3pf_1j28jx2 atm_nw6j9b_1j28jx2 atm_25w2w0_glywfm atm_1lmiy53_stnw88 atm_g026v9_idpfg4 atm_1jr3srq_176pqev atm_1qmbln3_1fks5bx atm_n9ko2d_1ssbidh atm_qntpbi_4t6vy3";
export interface CheckboxProps {
  checked: boolean;
  className?: string;
  controlTestId?: string;
  'data-testid'?: string;
  disabled?: boolean;
  label?: ReactNode;
  dense?: boolean;
  fullWidthLabel?: boolean;
  labelStart?: boolean;
  loading?: boolean;
  name?: string;
  onChange?(event: ChangeEvent<HTMLInputElement>): void;
  onClick?(event: MouseEvent<HTMLInputElement>): void;
  small?: boolean;
  title?: string;
  value?: string | number | boolean;
}
const Checkbox = (props: CheckboxProps) => {
  const {
    checked,
    className,
    controlTestId,
    dense = false,
    disabled = false,
    fullWidthLabel = false,
    label,
    labelStart = false,
    loading = false,
    name,
    onChange,
    onClick,
    small = false,
    title,
    value,
    'data-testid': dataTestId
  } = props;
  const isDisabled = disabled || loading;
  const {
    rippleRef,
    containerRef,
    onPointerDown
  } = useCenterRipple(isDisabled);
  return <label className={cx('mfc-checkbox', controlRootStyles, checkboxBoxStyles, small && controlSmallStyles, dense && controlDenseStyles, fullWidthLabel && controlFullWidthLabelStyles, labelStart && controlLabelStartStyles, loading && checkboxLoadingStyles, isDisabled && controlDisabledStyles, className)} data-checked={checked ? 'true' : 'false'} data-testid={dataTestId} onPointerDown={onPointerDown} title={title}>
            <span className="control-wrapper" data-testid={controlTestId} ref={containerRef}>
                <span aria-hidden="true" className="control-ripple" ref={rippleRef} />
                <input checked={checked} className="control-input" disabled={isDisabled} name={name} onChange={onChange} onClick={onClick} readOnly={!onChange} type="checkbox" value={value === undefined ? undefined : String(value)} />
                <span aria-hidden="true" className="control-box">
                    {loading && <span className="control-spinner" />}
                </span>
            </span>
            {label !== undefined && label !== null && <span className="control-text">{label}</span>}
        </label>;
};
export default Checkbox;